import { ApiV1SessionsDataAttributes, GetCashesData } from '@/api'

export interface AuthCallPayload {
  username: string
  password: string
  cashCode: string
  secondFactor?: string
  iam?: IAMCallResponse
}

export interface IAMCallResponse {
  access_token: string
  refresh_token: string
  scope: string
  id_token: string
  token_type: 'bearer'
  expires_in: number
}

export interface IUserMetadata {
  username: string
  name: string
  surname?: string
  email?: string
  uid?: string
}

export interface State {
  isAuthenticated: boolean
  sid?: string | null
  user?: ApiV1SessionsDataAttributes
  userMetadata?: IUserMetadata
  cashes: GetCashesData[]
  iam: IAMCallResponse | null
}

export const initState = (): State => ({
  isAuthenticated: false,
  sid: null,
  user: undefined,
  userMetadata: undefined,
  cashes: [],
  iam: null,
})
